import React from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';
import RedirectToDetail from './RedirectToDetail';
import StatusChip from './StatusChip';
import DeleteHPDTicket from './DeleteHPDTicket';

export const violationsColumns = [
  {
    field: "client_company_name",
    headerName: "Client",
    renderCell: (params) => (
      <Typography variant="body2">{params.value}</Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "building_address",
    headerName: "Building",
    renderCell: (params) => <RedirectToDetail params={params} />,
    minWidth: 180,
    flex: 1.5,
    sortable: false,
  },
  {
    field: "unit_number",
    headerName: "Unit",
    renderCell: (params) => params.value ?
      <p className="unit-ticket">{params.value}</p> :
      <p>N/A</p>,
    minWidth: 80,
    flex: 0.5,
    sortable: false,
  },
  {
    field: "violation_code",
    headerName: "Violation Code",
    renderCell: (params) => (
      <Typography variant="body2">{params.value}</Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "violation_id",
    headerName: "Violation #",
    renderCell: (params) => <RedirectToDetail params={params} />,
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "certify_by_date",
    headerName: "Correct Date",
    renderCell: (params) => (
      <Typography variant="body2">
        {params.value ? moment(params.value).format("MM/DD/YYYY") : "N/A"}
      </Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "correct_by_date",
    headerName: "Certify Date",
    renderCell: (params) => (
      <Typography variant="body2">
        {params.value ? moment(params.value).format("MM/DD/YYYY") : "N/A"}
      </Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "status",
    headerName: "Status",
    renderCell: (params) => <StatusChip status={params.value} />,
    minWidth: 150,
    flex: 1,
    sortable: false,
  },
  {
    field: "actions",
    headerName: "Action",
    renderCell: (params) => <DeleteHPDTicket params={params} />,
    minWidth: 100,
    flex: 0.5,
    sortable: false,
  },
  
]; 